module.exports = __webpack_public_path__ + "img/avatar-m2.45a3d9c0.png";